import EInvoicingConfiguration from "./config.type";
import { BrowserCacheLocation } from "@azure/msal-browser";

export const Configuration: EInvoicingConfiguration = {
    msalConfig: {
        auth: {
            clientId: "b6981f28-345b-4bb8-864a-ea6910dcbeb7",
            authority: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
            redirectUri: "http://localhost:3000", //http://localhost:3000 
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage, // localStorage persists across redirects through CDN/Front Door
        }
    },
    
    // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
    msalTokenRequest: {
        scopes: []
    },

    eventServiceUrl: "https://modern.einvoicing.eventservice.cp.microsoft-int.com",

    featureFlags: {
        manualInvoices: true,
        columnPicker: true,
        manualInvoiceCreator: true
    }
}